window.hideLogoFlag = false;

document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll(".close-pop-up-button-original").forEach(function(closeButton) {
    closeButton.addEventListener("click", function () {
      document.querySelectorAll(".cartWrapper").forEach(function(cartWrapper) {
        cartWrapper.style.display = 'none';
      });
    });
  });
  
  // Elements to be manipulated
  var brandMonphell = document.getElementById("brand-monphell-new");
  var brandLlehpnom = document.getElementById("brand-llehpnom-new");
  var monphellSection = document.getElementById("monphell-products-section");
  var llehpnomSection = document.getElementById("llehpnom-products-section");
  var relevantMonphell = document.getElementById("relevant-monphell");
  var relevantLlehpnom = document.getElementById("relevant-llehpnom");

  function updateDisplayBasedOnURL(url) {
      // Initial display settings
      if (brandMonphell) brandMonphell.style.display = "none";
      if (brandLlehpnom) brandLlehpnom.style.display = "none";
      if (monphellSection) monphellSection.style.display = "none";
      if (llehpnomSection) llehpnomSection.style.display = "none";
      if (relevantMonphell) relevantMonphell.style.display = "none";
      if (relevantLlehpnom) relevantLlehpnom.style.display = "none";

      // Flag to check if any condition matched
      let conditionMatched = false;

      // Check if URL is homepage without hash
      if (url.endsWith("/") || url.endsWith("/home")) {
          if (brandMonphell) brandMonphell.style.display = "flex";
          if (brandLlehpnom) brandLlehpnom.style.display = "none";
          if (monphellSection) monphellSection.style.display = "block";
          if (llehpnomSection) llehpnomSection.style.display = "none";
          conditionMatched = true;
      }

      // Check if URL contains hash #monphell
      if (url.includes("#monphell")) {
          if (brandMonphell) brandMonphell.style.display = "flex";
          if (brandLlehpnom) brandLlehpnom.style.display = "none";
          if (monphellSection) monphellSection.style.display = "block";
          if (llehpnomSection) llehpnomSection.style.display = "none";
          conditionMatched = true;
      }

      // Check if URL contains hash #llehpnom
      if (url.includes("#llehpnom")) {
          if (brandMonphell) brandMonphell.style.display = "none";
          if (brandLlehpnom) brandLlehpnom.style.display = "flex";
          if (monphellSection) monphellSection.style.display = "none";
          if (llehpnomSection) llehpnomSection.style.display = "block";
          conditionMatched = true;
      }

      // Check if URL contains /collections/llehpnom/products/
      if (url.includes("/collections/llehpnom/products/")) {
          if (brandMonphell) brandMonphell.style.display = "none";
          if (brandLlehpnom) brandLlehpnom.style.display = "flex";
          if (relevantMonphell) relevantMonphell.style.display = "none";
          if (relevantLlehpnom) relevantLlehpnom.style.display = "block";
          conditionMatched = true;
      }

      // Check if URL contains /collections/monphell/products/
      if (url.includes("/collections/monphell/products/")) {
          if (brandMonphell) brandMonphell.style.display = "flex";
          if (brandLlehpnom) brandLlehpnom.style.display = "none";
          if (relevantMonphell) relevantMonphell.style.display = "block";
          if (relevantLlehpnom) relevantLlehpnom.style.display = "none";
          conditionMatched = true;
      }

      // If none of the previous conditions matched
      if (!conditionMatched) {
          if (brandMonphell) brandMonphell.style.display = "flex";
          if (brandLlehpnom) brandLlehpnom.style.display = "none";
          if (monphellSection) monphellSection.style.display = "block";
          if (llehpnomSection) llehpnomSection.style.display = "none";
      }
  }

  // Initial check based on the current URL with a delay
  setTimeout(function() {
      updateDisplayBasedOnURL(window.location.href);
  }, 100);

  // Listen for URL changes
  window.addEventListener('hashchange', function() {
      updateDisplayBasedOnURL(window.location.href);
  });

  window.addEventListener('popstate', function() {
      updateDisplayBasedOnURL(window.location.href);
  });
});


(function () {
  document.addEventListener("DOMContentLoaded", function () {
    try {
      Array.from(document.querySelectorAll(".size-select-Btn")).forEach(sizeSelectBtn => {
        let listElement = sizeSelectBtn.parentElement.querySelector("ul");

        let opened = false;
        document.addEventListener("click", (e) => {
          if (e.target == sizeSelectBtn && opened == false) {
            sizeSelectBtn.classList.add("show");
            listElement.classList.add("show");
            listElement.setAttribute("style", "position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate3d(0px, 24px, 0px);");
            opened = true;
          } else if (opened == true) {
            sizeSelectBtn.classList.remove("show");
            listElement.classList.remove("show");
            listElement.setAttribute("style", "");
            opened = false;
          }
        });
      });
    } catch (error) {
      throw error;
    }

    document.getElementById("navbar").style.display = "flex";

    // var mainScreenItemMonphell = document.querySelector(".main-screen-item[onclick=\"showHeader('monphell')\"]");
    // var monphellLinksInLlehpnom = document.querySelectorAll(".brand-llehpnom-link");
    
    // // if (mainScreenItemMonphell) {
    // //   mainScreenItemMonphell.addEventListener("click", function () {
    // //     showHeader("monphell");
    // //   });
    // // }
    
    // if (monphellLinksInLlehpnom.length > 0) {
    //   monphellLinksInLlehpnom.forEach(function(link) {
    //     link.addEventListener("click", function () {
    //       hideElement(".privacy-text-container");
    //       showHeader("monphell");
    //     });
    //   });
    // }

    // var mainScreenItemLlehpnom = document.querySelector(".main-screen-item[onclick=\"showHeader('llehpnom')\"]");
  // var llehpnomLinksInMonphell = document.querySelectorAll(".brand-monphell-link");

  // // if (mainScreenItemLlehpnom) {
  // //   mainScreenItemLlehpnom.addEventListener("click", function () {
  // //     showHeader("llehpnom");
  // //   });
  // // }

  // if (llehpnomLinksInMonphell.length > 0) {
  //   llehpnomLinksInMonphell.forEach(function(link) {
  //     link.addEventListener("click", function () {
  //       hideElement(".privacy-text-container");
  //       showHeader("llehpnom");
  //     });
  //   });
  // }


    // var menuList = document.querySelector(".navbar-menu-open");
    // var shopList = document.querySelector(".navbar-shop-open");

    // var menuButton = document.querySelector(".menu-item");
    // var shopButton = document.querySelector(".shop-item");
   
    // var shopBtn = document.getElementsByClassName("shop-item")[0];
    // var menuBtn = document.getElementsByClassName("menu-item")[0];


    // menuButton.addEventListener("click", function () {
    //   menuList.style.display = "block";

    //   menuBtn.style.borderColor = "#0007FF";
    //   shopList.style.display = "none";
 
    //   shopBtn.style.borderColor = "black";
    // });

    // menuList.addEventListener("mouseleave", function () {
    //   menuList.style.display = "none";
 
    //   menuBtn.style.borderColor = "black";
    // });
    // shopList.addEventListener("mouseleave", function () {
    //   shopList.style.display = "none";
    
    //   shopBtn.style.borderColor = "black";
    // });

    // shopButton.addEventListener("click", function () {
    //   shopList.style.display = "block";
   
    //   shopBtn.style.borderColor = "#0007FF";
    //   menuList.style.display = "none";
  
    //   menuBtn.style.borderColor = "black";
    // });

    // var menuItems = document.querySelectorAll(".navbar-menu-open-list li, .navbar-shop-open-list li");

    // menuItems.forEach(function (item) {
    //   item.addEventListener("click", function () {
    //     menuItems.forEach(function (i) {
    //       i.classList.remove("list-item-selected");
    //     });

    //     item.classList.add("list-item-selected");
    //   });
    // });

    // document.getElementById("close-btn-menu").addEventListener("click", () => {
    //   var menu = document.querySelector(".navbar-menu-open");
    //   menu.style.display = "none";
   
    //   menuBtn.style.borderColor = "black";
    // });
    // document.getElementById("close-btn-shop").addEventListener("click", () => {
    //   var shop = document.querySelector(".navbar-shop-open");
    //   shop.style.display = "none";
 
    //   shopBtn.style.borderColor = "black";
    // });

    document.querySelectorAll("#headwear").forEach(function(headWear) {
      headWear.addEventListener("click", function () {
      
        localStorage.setItem('lastClicked', 'headwear');
        filterClothes("headwear");
        document.querySelector('.monphell-hero-section').style.display = 'none';
        if (window.innerWidth < 991) {
          document.querySelector('.monphell-products-section').style.paddingTop = '32px';
        } else {
          document.querySelector('.monphell-products-section').style.paddingTop = '120px';
        }
      });
    });
    
    document.querySelectorAll("#tops-button").forEach(function(topClothes) {

      topClothes.addEventListener("click", function () {
        localStorage.setItem('lastClicked', 'tops');
        filterClothes("tops");
        document.querySelector('.monphell-hero-section').style.display = 'none';
        if (window.innerWidth < 991) {
          document.querySelector('.monphell-products-section').style.paddingTop = '32px';
        } else {
          document.querySelector('.monphell-products-section').style.paddingTop = '120px';
        }
      });
    });
    
    document.querySelectorAll("#bottoms").forEach(function(bottomClothes) {

      bottomClothes.addEventListener("click", function () {
        localStorage.setItem('lastClicked', 'bottoms');
        filterClothes("bottoms");
        document.querySelector('.monphell-hero-section').style.display = 'none';
        if (window.innerWidth < 991) {
          document.querySelector('.monphell-products-section').style.paddingTop = '32px';
        } else {
          document.querySelector('.monphell-products-section').style.paddingTop = '120px';
        }
      });
    });
    
    // document.querySelector("#privacy-policy").addEventListener("click", function () {
    //   showFirstBlockSecondNone(".privacy-text-container2", "#productImagesSection");

    //   showFirstBlockSecondNone(".privacy-text-container2", ".privacy-text-container");
    // });
    document.querySelectorAll("#SHIPPING").forEach(function (element) {
      element.addEventListener("click", function () {
        showFirstBlockSecondNone(".privacy-text-container", "#productImagesSection");
        showFirstBlockSecondNone(".privacy-text-container", ".privacy-text-container2");
    
        // Change the color of #SHIPPING elements to #0007FF
        element.style.color = "#0007FF";
    
        // Change the color of .privacy-policy3 to #000
        document.querySelectorAll("#privacy-policy3").forEach(function (policyElement) {
          policyElement.style.color = "#000";
        });

        const menuOpen = document.querySelector('.menu-link-open');
        const menuClose = document.querySelector('.menu-link-close');
        const menuWrapper = document.querySelector('.menu-mobile-wrapper');
    
        if (menuOpen && menuClose && menuWrapper) {
          menuOpen.addEventListener('click', function() {
            menuWrapper.style.display = 'flex';
            menuOpen.style.display = 'none';
            menuClose.style.display = 'block';
          });
    
          menuClose.addEventListener('click', function() {
            menuWrapper.style.display = 'none';
            menuOpen.style.display = 'block';
            menuClose.style.display = 'none';
            removeActiveClassFromItems();
          });
        }
      });
    });
    
    
    document.querySelectorAll("#privacy-policy3").forEach(function (element) {
      element.addEventListener("click", function () {
        showFirstBlockSecondNone(".privacy-text-container2", "#productImagesSection");
        showFirstBlockSecondNone(".privacy-text-container2", ".privacy-text-container");
    
        var elements3 = document.querySelectorAll("#SHIPPING");
        elements3.forEach(function (element3) {
          if (element3) {
            element3.classList.remove("list-item-selected");
            // Change the color of #SHIPPING elements to #000
            element3.style.color = "#000";
          }
        });
    
        var elements2 = document.querySelectorAll("#privacy-policy");
        elements2.forEach(function (element2) {
          if (element2) {
            element2.classList.add("list-item-selected");
          }
        });
    
        // Change the color of #privacy-policy3 elements to #0007FF
        element.style.color = "#0007FF";

        const menuOpen = document.querySelector('.menu-link-open');
        const menuClose = document.querySelector('.menu-link-close');
        const menuWrapper = document.querySelector('.menu-mobile-wrapper');
    
        if (menuOpen && menuClose && menuWrapper) {
          menuOpen.addEventListener('click', function() {
            menuWrapper.style.display = 'flex';
            menuOpen.style.display = 'none';
            menuClose.style.display = 'block';
          });
    
          menuClose.addEventListener('click', function() {
            menuWrapper.style.display = 'none';
            menuOpen.style.display = 'block';
            menuClose.style.display = 'none';
            removeActiveClassFromItems();
          });
        }
      });
    });
    
    




    
    document.querySelectorAll("#all-button").forEach(function(button) {
      button.addEventListener("click", function () {

      
        showFirstBlockSecondNone("#productImagesSection", ".privacy-text-container2");
        document.querySelector('.monphell-hero-section').style.display = 'block';
        document.querySelector('.monphell-products-section').style.paddingTop = '100vh';
    
        var element3 = document.querySelector("#SHIPPING");
        if (element3) {
          element3.classList.remove("list-item-selected");
          element3.style.color = "#000";
        }
    
        var element2 = document.querySelector("#privacy-policy");
        if (element2) {
          element2.classList.remove("list-item-selected");
        }

        document.querySelectorAll("#privacy-policy3").forEach(function(policyElement) {
          policyElement.style.color = "#000"; // Change color to #000
        });
    
        localStorage.setItem('lastClicked', 'all');
        removeTag();
      });
    });

    document.querySelectorAll("#tops-button-tops-llehp").forEach(function(topClothes) {
      topClothes.addEventListener("click", function () {
        showFirstBlockSecondNone("#productImagesSection", ".privacy-text-container2");
    
        var element3 = document.querySelector("#SHIPPING");
        if (element3) {
          element3.classList.remove("list-item-selected");
          element3.style.color = "#000";
        }
    
        var element2 = document.querySelector("#privacy-policy");
        if (element2) {
          element2.classList.remove("list-item-selected");
        }

        document.querySelectorAll("#privacy-policy3").forEach(function(policyElement) {
          policyElement.style.color = "#000"; // Change color to #000
        });
  
          localStorage.setItem('lastClicked', 'tops');
          
          // Explicitly set the hash to #llehpnom
          window.location.hash = "#llehpnom";
          
          filterClothes("tops");
      });
  });
  
  document.querySelectorAll("#all-button-all-llehp").forEach(function(button) {
      button.addEventListener("click", function () {

        showFirstBlockSecondNone("#productImagesSection", ".privacy-text-container2");
    
        var element3 = document.querySelector("#SHIPPING");
        if (element3) {
          element3.classList.remove("list-item-selected");
          element3.style.color = "#000";
        }
    
        var element2 = document.querySelector("#privacy-policy");
        if (element2) {
          element2.classList.remove("list-item-selected");
        }

        document.querySelectorAll("#privacy-policy3").forEach(function(policyElement) {
          policyElement.style.color = "#000"; // Change color to #000
        });
    
     
          localStorage.setItem('lastClicked', 'all');
          
          // Explicitly set the hash to #llehpnom
          window.location.hash = "#llehpnom";
          
          removeTag();
  
      });
  });
  

    document.querySelectorAll("#tops-button").forEach(function(button) {
      button.addEventListener("click", function () {
        showFirstBlockSecondNone("#productImagesSection", ".privacy-text-container2");
    
        var element3 = document.querySelector("#SHIPPING");
        if (element3) {
          element3.classList.remove("list-item-selected");
          element3.style.color = "#000";
        }
    
        var element2 = document.querySelector("#privacy-policy");
        if (element2) {
          element2.classList.remove("list-item-selected");
        }

        document.querySelectorAll("#privacy-policy3").forEach(function(policyElement) {
          policyElement.style.color = "#000"; // Change color to #000
        });
      });
    });
    
    document.querySelectorAll("#bottoms").forEach(function(button) {
      button.addEventListener("click", function () {
        showFirstBlockSecondNone("#productImagesSection", ".privacy-text-container2");
    
        var element3 = document.querySelector("#SHIPPING");
        if (element3) {
          element3.classList.remove("list-item-selected");
          element3.style.color = "#000";
        }
    
        var element2 = document.querySelector("#privacy-policy");
        if (element2) {
          element2.classList.remove("list-item-selected");
        }

        document.querySelectorAll("#privacy-policy3").forEach(function(policyElement) {
          policyElement.style.color = "#000"; // Change color to #000
        });
      });
    });

    document.querySelectorAll("#headwear").forEach(function(button) {
      button.addEventListener("click", function () {
        showFirstBlockSecondNone("#productImagesSection", ".privacy-text-container2");
    
        var element3 = document.querySelector("#SHIPPING");
        if (element3) {
          element3.classList.remove("list-item-selected");
          element3.style.color = "#000";
        }
    
        var element2 = document.querySelector("#privacy-policy");
        if (element2) {
          element2.classList.remove("list-item-selected");
        }

        document.querySelectorAll("#privacy-policy3").forEach(function(policyElement) {
          policyElement.style.color = "#000"; // Change color to #000
        });
      });
    });
    


// Add event listeners for all elements with the ID #all-button
document.querySelectorAll("#all-button").forEach(function(allClothes) {
  allClothes.addEventListener("click", function () {
    localStorage.setItem('lastClicked', 'all');
    removeTag();
  });
});


    var cartAtBackground = document.querySelector("#cart-background");
    const cartWrapper = document.querySelector(".cartWrapper");
    const shopping_cart_table = document.querySelector(".shopping-cart-table");
    var btnCart = document.querySelector(" .cart-Btn");
    cartAtBackground.addEventListener("click", function () {
      cartWrapper.style.display = "block";
      btnCart.style.borderColor = "#0007FF";
    });

    cartWrapper.addEventListener("click", function (event) {
      cartWrapper.style.display = "none";
      btnCart.style.borderColor = "#000000";
    });

    shopping_cart_table.addEventListener("click", function (event) {
      event.stopPropagation();
    });
    
    $(document).ready(function () {
      $("#contact").on("show.bs.modal", function () {
        $(".world-wide-close").css({
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }).show();
        closeMenuView();
      });

      $("#newsletter").on("show.bs.modal", function () {
        $(".world-wide-close").css({
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }).show();
        closeMenuView();
      });

      $("#about-us").on("show.bs.modal", function () {
        $(".world-wide-close").css({
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }).show();
        closeMenuView();
      }).on("hide.bs.modal", function () {
        $(this).attr("aria-modal", "false");
        $(".world-wide-close").hide();
        closeMenuView();
      });

      $(".world-wide-close").click(function () {
        var openModal = $(".modal.show");
        if (openModal.length) {
          var bootstrapModal = bootstrap.Modal.getInstance(openModal[0]);
          bootstrapModal.hide();
        }
      });
    });

    // document.getElementById("privacy-policy").onclick = () => {
    //   closeMenuView();
    // };
    document.getElementById("SHIPPING").onclick = () => {
      closeMenuView();
    };

    // if (isProductsPage) {
    //   stopTimer();
    //   document.getElementById("navbar").style.display = "flex";
    // }

    document.addEventListener('DOMContentLoaded', function() {
      // Get references to the about button and the wrapper elements
      var aboutUsBtn = document.getElementById("aboutUsBtn");
      var insetWrapper = document.querySelector(".inset-wrapper");
      var controllingContainer = document.querySelector(".controlling-container");
      var aboutCloseIcon = document.getElementById("about-close-icon");
    
      // Check if the elements exist
      if (aboutUsBtn && insetWrapper && controllingContainer && aboutCloseIcon) {
      
    
        // Add event listener to the about button
        aboutUsBtn.addEventListener('click', function() {
     
    
          // Remove 'd-none' class and add 'd-flex' class
          aboutCloseIcon.classList.remove("d-none");
          aboutCloseIcon.classList.add("d-flex");
          insetWrapper.classList.remove("d-none");
          controllingContainer.classList.remove("d-none");
    
        
        });
    
        // Add event listener to the inset wrapper to hide it when clicked
        insetWrapper.addEventListener('click', function() {
       
    
          aboutCloseIcon.classList.add("d-none");
          aboutCloseIcon.classList.remove("d-flex");
          controllingContainer.classList.add("d-none");
          insetWrapper.classList.add("d-none");
    

        });
    
        // Prevent propagation of click events inside the modal content wrapper
        var modalContentWrapper = document.querySelector(".modal-content-wrapper");
        if (modalContentWrapper) {
          modalContentWrapper.addEventListener('click', function(event) {
            event.stopPropagation();
         
          });
        }
      } else {
     
      }
    });
    

  });
})();

function toggleMenu() {
  var menu = document.querySelector(".navbar-menu-open");
  if (menu.style.display === "none" || menu.style.display === "") {
    menu.style.display = "flex";
  } else {
    menu.style.display = "none";
  }
}
function toggleShop() {
  var shop = document.querySelector(".navbar-shop-open");
  if (shop.style.display === "none" || shop.style.display === "") {
    shop.style.display = "flex";
  } else {
    shop.style.display = "none";
  }
}

// function showHeader(brand) {
//   document.getElementById("navbar").style.display = "flex";
//   document.getElementById("brand-monphell").style.display = "none";
//   document.getElementById("brand-llehpnom").style.display = "none";
//   actualShowHeader(brand);
// }

// function actualShowHeader(brand) {
//   console.log("BRAND: " + brand);
//   InitializeTimer(brand);
//   showElement("#productImagesSection");
//   document.getElementById("navbar").style.display = "flex";
//   var privacyPolicyElement = document.getElementById('privacy-policy');

//   if (brand === "monphell") {
//     window.location.href = "#monphell";
//     setMonphellFlag(true);
//     setLlehpnomFlag(false);
//     document.querySelectorAll("#brand-monphell").forEach(function (element) {
//       element.style.display = "flex";
//     });
//     showFirstBlockSecondNone(".monphell-products-section", ".llehpnom-products-section");
//     showFirstBlockSecondNone(".monphell-products-section", ".privacy-text-container2");
//     if (privacyPolicyElement) {
//       privacyPolicyElement.classList.remove('list-item-selected');
//     }
//   } else if (brand === "llehpnom") {
//     window.location.href = "#llehpnom";
//     setMonphellFlag(false);
//     setLlehpnomFlag(true);
//     document.querySelectorAll("#brand-llehpnom").forEach(function (element) {
//       element.style.display = "flex";
//     });
//     showFirstBlockSecondNone(".llehpnom-products-section", ".monphell-products-section");
//     showFirstBlockSecondNone(".llehpnom-products-section", ".privacy-text-container2");
//     if (privacyPolicyElement) {
//       privacyPolicyElement.classList.remove('list-item-selected');
//     }
//   }

//   opacityON("#navbar");
//   hideElement("#loading-images-container-wrapper");
// }

function filterClothes(tagName) {
  var allProducts = document.querySelectorAll(".product-images");
  var privacyPage = document.getElementsByClassName("privacy-text-container")[0];
  var shopList = document.querySelector(".menu-mobile-wrapper");
  document.getElementById("productImagesSection").style.display = "flex";
  shopList.style.display = "none";
  privacyPage.style.display = "none";
  allProducts.forEach(function (product) {
    var productTags = product.getAttribute("data-tag");
    if (productTags && productTags.includes(tagName)) {
      product.style.display = "grid";
    } else {
      product.style.display = "none";
    }
  });
}

function showFirstBlockSecondNone(displaySelector, noneSelector) {
  let displayEl = document.querySelector(displaySelector);
  if(!displayEl) {
   //console.log(displaySelector);
  } else {
    displayEl.style.display = "block";
  }

  let noneEl = document.querySelector(noneSelector);
  if(!noneEl) {
   console.log(noneEl);
  } else {
    noneEl.style.display = "none";
  }
}
// function hideMainScreen() {
//   document.getElementById("main-screen").style.display = "none";
// }
// function hideBothBrands() {
//   document.getElementById("brand-monphell").style.display = "none";
//   document.getElementById("brand-llehpnom").style.display = "none";
// }
function showFirstBlockSecondAndThirdNone(displaySelector, firstNoneSelector, secondNoneSelector) {
  document.querySelector(displaySelector).style.display = "block";
  document.querySelector(firstNoneSelector).style.display = "none";
  document.querySelector(secondNoneSelector).style.display = "none";
}
function showElement(selector) {
  if (!selector) return;
  const element = document.querySelector(selector);
  if (element) element.style.display = "block";
}

function hideElement(selector) {
  if (!selector) return;
  const element = document.querySelector(selector);
  if (element) element.style.display = "none";
}

function removeTag() {
  var shopList = document.querySelector(".menu-mobile-wrapper");
  var allProducts = document.querySelectorAll(".product-images");
  var privacyPage = document.getElementsByClassName("privacy-text-container")[0];
  shopList.style.display = "none";
  privacyPage.style.display = "none";
  document.getElementById("productImagesSection").style.display = "block";
  allProducts.forEach(function (product) {
    product.style.display = "grid";
  });
}
function opacityON(elementId) {
  var element = document.querySelector(elementId);
  if (element) {
    element.style.opacity = "1";
  }
}

function opacityOFF(elementId) {
  var element = document.querySelector(elementId);
  if (element) {
    element.style.opacity = "0";
  }
}

function closeMenuView() {
  var menu = document.querySelector(".navbar-menu-open");
  var menuBtn = document.getElementsByClassName("menu-item")[0];
  menu.style.display = "none";
  menuBtn.style.borderColor = "#000000";
}
// Function to update the flags
function setMonphellFlag(value) {
  let monphellFlag = value;
  localStorage.setItem("monphellFlag", value.toString());
}

function setLlehpnomFlag(value) {
  let llehpnomFlag = value;
  localStorage.setItem("llehpnomFlag", value.toString());
}

// if (typeof window.resetTimer === "undefined") {
//   window.resetTimer = () => {
//     clearTimeout(window.timer);
//     if (window.innerWidth >= 991) {
//       window.timer = setTimeout(window.showLogo, 10000);
//     }
//   };

//   const stopResetTimer = (event) => {
//     event.stopPropagation();
//     if (window.innerWidth < 991) {
//       event.preventDefault();
//     }
//   };

//   document.querySelectorAll('.product-images').forEach(element => {
//     element.addEventListener('mouseover', stopResetTimer);

//     element.addEventListener('mouseout', window.resetTimer);
//   });
// }


// if (typeof window.hideLogo === "undefined") {
//   window.hideLogo = () => {
//     if (localStorage.getItem("monphellFlag") === "true") {
//       opacityON("#navbar");
//       document.getElementById("navbar").style.display = "flex";
//       hideElement("#loading-monphell");
//       hideElement("#loading-images-container-wrapper");
//     }
//     if (localStorage.getItem("llehpnomFlag") === "true") {
//       opacityON("#navbar");
//       document.getElementById("navbar").style.display = "flex";
//       hideElement("#loading-llehpnom");
//       hideElement("#loading-images-container-wrapper");
//     }
//   };
// }

// if (typeof window.showLogo === "undefined") {
//   window.showLogo = () => {
//     if (localStorage.getItem("monphellFlag") === "true") {
//       opacityOFF("#navbar");
//       document.getElementById("navbar").style.display = "flex";
//       showElement("#loading-monphell");
//       showElement("#loading-images-container-wrapper");
//     }
//     if (localStorage.getItem("llehpnomFlag") === "true") {
//       opacityOFF("#navbar");
//       document.getElementById("navbar").style.display = "flex";
//       showElement("#loading-llehpnom");
//       showElement("#loading-images-container-wrapper");
//     }
//   };
// }

// if (typeof window.startTimer === "undefined") {
//   window.startTimer = () => {
//     window.resetTimer();
//     window.addEventListeners();
//   };
// }

// if (typeof window.stopTimer === "undefined") {
//   window.stopTimer = () => {
//     clearTimeout(window.timer);
//     window.removeEventListeners();
//   };
// }


// if (typeof window.addEventListeners === "undefined") {
//   window.addEventListeners = () => {
//     ["click", "load", "keypress", "scroll"].forEach((event) => {
//       window.addEventListener(event, resetTimer, true);
//     });
//   };
// }

// if (typeof window.removeEventListeners === "undefined") {
//   window.removeEventListeners = () => {
//     ["click", "load", "keypress"].forEach((event) => {
//       window.removeEventListener(event, resetTimer, true);
//     });
//   };
// }

// if (typeof window.InitializeTimer === "undefined") {
//   window.InitializeTimer = (brand) => {
//     document.getElementById("navbar").style.display = "flex";
//     startTimer();

//     ["click", "load", "keypress"].forEach((event) => {
//       window.addEventListener(
//         event,
//         () => {
//           hideLogo();
//           resetTimer();
//         },
//         true
//       );
//     });
//   };
// }

// window.addEventListener('hashchange', function () {
//   setTimeout(window.hideLogoOnLoad, 500);
// });

document.addEventListener('DOMContentLoaded', function () {
  var ulElement = document.querySelector('.navbar-menu-open-list');
  var closeBtn = document.getElementById('close-btn-menu');

  if (ulElement && closeBtn) {
    ulElement.addEventListener('click', function (event) {
      if (event.target.tagName === 'LI' || event.target.closest('li')) {
        closeBtn.click();
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var ulElementShop = document.querySelector('.navbar-shop-open-list');
  var closeBtnShop = document.getElementById('close-btn-shop');

  if (ulElementShop && closeBtnShop) {
    ulElementShop.addEventListener('click', function (event) {
      if (event.target.tagName === 'LI' || event.target.closest('li')) {
        closeBtnShop.click();
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const elements = document.querySelectorAll('.to-fade-in');

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const threshold = viewportHeight * 0.15;  // 10% of the viewport height

    return (
      rect.top <= (viewportHeight - threshold) && // Element top comes within 10% of viewport bottom
      rect.bottom >= threshold  // Element bottom is within 10% of viewport top
    );
  }

  function fadeInOnScroll() {
    elements.forEach(element => {
      if (isElementInViewport(element)) {
        element.classList.add('fade-in');
      }
    });
  }

  window.addEventListener('scroll', fadeInOnScroll);
  fadeInOnScroll(); // Trigger the animation on initial load
  



});


document.querySelectorAll(".shop-btn-mobile").forEach(function (element) {
  element.addEventListener("click", function () {
    // Toggle text color of clicked element
    if (element.style.color === "rgb(0, 7, 255)") {
      element.style.color = "#000000";
    } else {
      element.style.color = "#0007FF";
    }

    // Toggle display property of .menu-mob-right-part-wrapper
    var menuWrapper = document.querySelector(".menu-mob-right-part-wrapper");
    if (menuWrapper) {
      if (menuWrapper.style.display === "block") {
        menuWrapper.style.display = "none";
      } else {
        menuWrapper.style.display = "block";
      }
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Function to change the color of all elements with id aboutUsBtn
  function changeColorToBlue() {
    document.querySelectorAll('#aboutUsBtn').forEach(function(element) {
      element.style.color = '#0007FF';
    });
  }

  // Function to change the color of all elements with id aboutUsBtn back to black
  function changeColorToBlack() {
    document.querySelectorAll('#aboutUsBtn').forEach(function(element) {
      element.style.color = '#000000';
    });
  }

  // Add event listener to all elements with id aboutUsBtn
  document.querySelectorAll('#aboutUsBtn').forEach(function(element) {
    element.addEventListener('click', changeColorToBlue);
  });

  // Add event listener to all elements with class controlling-container
  document.querySelectorAll('.controlling-container').forEach(function(element) {
    element.addEventListener('click', changeColorToBlack);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Function to change the color of all elements with id contactBtn
  function changeColorToBlue() {
    document.querySelectorAll('#contactBtn').forEach(function(element) {
      element.style.color = '#0007FF';
    });
  }

  // Function to change the color of all elements with id contactBtn back to black
  function changeColorToBlack() {
    document.querySelectorAll('#contactBtn').forEach(function(element) {
      element.style.color = '#000000';
    });
  }

  // Add event listener to all elements with id contactBtn
  document.querySelectorAll('#contactBtn').forEach(function(element) {
    element.addEventListener('click', changeColorToBlue);
  });

  // Add event listener to all elements with class controlling-container-contact
  document.querySelectorAll('.controlling-container-contact').forEach(function(element) {
    element.addEventListener('click', changeColorToBlack);
  });
});